// extracted by mini-css-extract-plugin
export default {"home":"Branches_home__mAjN9","textFields":"Branches_textFields__-NfcX","actionButton":"Branches_actionButton__H0Jxa","error":"Branches_error__Oc9XV","flex":"Branches_flex__7ZOFC"};